/**
 * Saved Decks — list and load user decks
 */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchJson } from './api.js';

export default function SavedDecksView() {
  const navigate = useNavigate();
  const [decks, setDecks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJson('/api/decks')
      .then(setDecks)
      .catch(() => setDecks([]))
      .finally(() => setLoading(false));
  }, []);

  const openDeck = (deck) => {
    navigate('/deck-builder', { state: { loadDeckId: deck._id } });
  };

  return (
    <div className="saved-decks-view">
      <div className="gallery-header">
        <h1>Saved Decks</h1>
        <p className="gallery-stats">{decks.length} / 40 decks</p>
      </div>
      {loading ? (
        <div className="gallery-loading">Loading...</div>
      ) : (
        <div className="decks-grid">
          {decks.map((deck) => (
            <button
              key={deck._id}
              type="button"
              className="deck-card-preview"
              onClick={() => openDeck(deck)}
            >
              <span className="deck-preview-name">{deck.name || 'Untitled'}</span>
              {deck.legend?.id && <span className="deck-preview-meta">Legend: {deck.legend.id}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
